module.exports = __webpack_public_path__ + "img/reservar.a6f4d249.png";